import { DASHBOARD_DETAIL_ADMIN, DASHBOARD_GRAPH,NEW_DASHBOARD_DETAILS ,
  DASHBOARD_SOURCING,DASHBOARD_CLOSING,
  DASHBOARD_SITEHEAD,DASHBOARD_SCM,
  DASHBOARD_RECEIPTIONIST,DASHBOARD_POSTSALE,
  DASHBOARD_CSTL
} from "../types";

const initialState = {
  response: null,
  graphResponse: null,
  dashboardDetails:null,
  loading: true,
  create: false,
  detail: false,
};

export default function dashboardDataStore(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_DETAIL_ADMIN:
      return {
        ...state,
        create: false,
        detail: false,
        loading: false,
        response: action.payload,
      };
    case DASHBOARD_GRAPH:
      return {
        ...state,
        create: false,
        detail: false,
        graphResponse: action.payload,
      };
      case NEW_DASHBOARD_DETAILS:
      return {
        ...state,
        create: false,
        detail: false,
        dashboardDetails: action.payload,
      };
      case DASHBOARD_SOURCING:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };
        case DASHBOARD_CLOSING:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };
        case DASHBOARD_SCM:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };
        case DASHBOARD_SITEHEAD:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };
        case DASHBOARD_POSTSALE:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };
        case DASHBOARD_RECEIPTIONIST:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };
        case DASHBOARD_CSTL:
        return {
          ...state,
          create: false,
          detail: false,
          loading: false,
          response: action.payload,
        };

    default:
      return state;
  }
}
